import React, { useState } from 'react'
import { getMostPermissiveRole } from '../roles'
import { CsResetIcon } from '../../legacy-design-system/icons'
import { FormattedMessage } from 'react-intl'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { ResetDialog } from '../applications-grid/actions/reset-dialog'
import { useCurrentOrganization, useCurrentUser } from 'contrastBase/state'

interface Props {
  application: {
    appId: string
  }
  appName: string
}

const linkStyle = css`
  color: ${theme.color.teal50};
  cursor: pointer;
`

const resetIconSize = 15

export function ResetApplication({ application, appName }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  const { currentOrganization } = useCurrentOrganization()
  const { organizationUuid: organizationID, isFreemium } =
    currentOrganization || {}

  const { currentUser } = useCurrentUser()
  const role = getMostPermissiveRole(currentUser?.roles || [])

  if (isFreemium || role !== 'ADMIN') {
    return null
  }

  const props = {
    application: {
      name: appName,
      id: application.appId,
      archived: false,
      role,
      tags: []
    },
    isFreemium: !!isFreemium,
    refetchQueries: [],
    refresh: () => new Promise(() => null),
    organizationID: organizationID as string
  }

  const handleClick = () => {
    setIsOpen(true)
  }

  return (
    <>
      <div onClick={handleClick}>
        <CsResetIcon width={resetIconSize} height={resetIconSize} />
        &nbsp;
        <span className={cx(linkStyle)}>
          <FormattedMessage
            id="action_applications_reset_application"
            defaultMessage="Reset"
          />
        </span>
      </div>
      {isOpen && (
        <ResetDialog
          isOpen={isOpen}
          closeDialog={() => setIsOpen(false)}
          className={css`
            z-index: 2050;
          `}
          {...props}
        />
      )}
    </>
  )
}
